import {ValidationModalSection} from "~/models/navigableValidations/validationSections";
import {IErrorNavOpts} from "~/models/validationError";
import {Route} from "~/enums/route";
import {RouteHelper} from "~/helpers/routeHelper";
import NavigableValidator from "~/models/navigableValidators/navigableValidator";
import {ErrorType} from "~/enums/ErrorType";
import Analytic from "~/models/dashboards/elements/analytic";
import FieldPresenceValidator from "~/models/navigableValidators/fieldPresenceValidator";
import DashboardElementValidation from "~/models/navigableValidations/dashboardElementValidation";
import ListViewElement from "~/models/dashboards/elements/listViewElement";

export default class DashboardElementAnalyticValidation extends DashboardElementValidation<Analytic> {
  validators = new DashboardElementValidation(this.model).validators.concat([
    new FieldPresenceValidator({
      validatorKey: 'visualization_id',
      section: ValidationModalSection.Analytics,
      type: ErrorType.mustBeConfigured,
      displayName: "Analytic Element",
      message: 'Please select Visualization...',
    }),

    new NavigableValidator({
      validatorKey: "analytics",
      section: ValidationModalSection.Analytics,
      conditional: (model: Analytic , validatorKey) => {
        // visualization is selected
        return !!model.visualization_id
      },
      validator: (value, model: Analytic) => {
        return model.visualization.is_published
      },
      message: "Visualization is not published",
      type: ErrorType.mustBePublished,
      displayName: (key, model: Analytic) => {
        return model.visualization.title
      }
    }),
    new FieldPresenceValidator({
      validatorKey: 'drill_down_visualization',
      section: ValidationModalSection.Analytics,
      displayName: "Drill down for Analytic Element",
      type: ErrorType.mustBeConfigured,
      conditional: (model: Analytic) => {
        return !!model.drill_down && (!model.form_id && !model.list_view_id)
      },
    }),
  ]);


  errorNavOpts(validator, validatorKey: string, value?, errorType?: string): IErrorNavOpts {
    let baseOpts = super.errorNavOpts(validator, validatorKey, value, errorType);
    let model = this.model as Analytic
    if (validatorKey === "analytics") {
      baseOpts.useLocation = `${RouteHelper.path({route: Route.editVisualization, modelOrId: model.visualization})}`;
    }else if (validatorKey === "visualization_id" || validatorKey === 'drill_down_visualization') {
      baseOpts.path = ValidationModalSection.Layout.toLowerCase();
    }
    return baseOpts;
  };
}